import * as fromPromotionActions from '../actions/promotions.action';
import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';
import {Observable} from 'rxjs';
import {PromotionsRestService} from '../../services/api/promotions.rest-service';

@Injectable()
export class PromotionsEffects {
    private actions$ = inject(Actions);
    private promotionsRestService = inject(PromotionsRestService);

    loadPromotions$: Observable<Action> = createEffect(() =>
        this.actions$
            .pipe(ofType<fromPromotionActions.InitLoadAllPromotions>(fromPromotionActions.PromotionsActionTypes.INIT_LOAD_ALL_PROMOTIONS))
            .pipe(map(action => action), switchMap((rq) =>
                    this.promotionsRestService.loadAllPromotions(rq.payload).pipe(
                        map(data => new fromPromotionActions.LoadAllPromotionsComplete(data.returnObject)),
                        catchError((error) => of(new fromPromotionActions.LoadAllPromotionsFailed(error)))
                    )
                )
            )
    );
}
